export const getLastFromMinLengthArray = <Data>(
  arr: MinLengthArray<1, Data>,
): Data => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return arr.slice(-1)[0]!;
};
